import { useCache } from '@/hooks/web/useCache'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'
import zhTw from 'element-plus/es/locale/lang/zh-tw'
import ja from 'element-plus/es/locale/lang/ja'
const { wsCache } = useCache()

export const elLocaleMap = {
  'zh-CN': zhCn,
  en: en,
  'zh-TW': zhTw,
  ja: ja
}
export interface LocaleState {
  currentLocale: LocaleDropdownType
  localeMap: LocaleDropdownType[]
}

export const localeModules: LocaleState = {
  currentLocale: {
    lang: wsCache.get('lang') || 'zh-CN',
    elLocale: elLocaleMap[wsCache.get('lang') || 'zh-CN']
  },
  // 多语言
  localeMap: [
    {
      lang: 'zh-CN',
      name: '简体中文'
    },
    {
      lang: 'zh-TW',
      name: '繁体中文'
    },
    {
      lang: 'en',
      name: 'English'
    },
    {
      lang: 'ARA',
      name: '阿拉伯语'
    },
  ]
}
